import { useContextSelector } from 'use-context-selector';
import { AuthContext } from 'store/contexts/auth';
import { AuthState } from 'store/types/auth';
import { AUTH_TOKEN_STORAGE_KEY } from 'utils/constants';

interface Manager {
  setAuthLoading: { (): void };
  authenticate: { (token: string): void };
  deauthenticate: { (): void };
}

export const useAuthStateManager = (): Manager => {
  const setAuthState = useContextSelector(
    AuthContext,
    context => context.setState,
  );

  const setAuthLoading = (): void => {
    setAuthState(state => ({ ...state, isLoading: true }));
  };

  const authenticate = (token: string): void => {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    setAuthState(state => ({
      ...state,
      isAuthenticated: true,
      isLoading: false,
    }));
  };

  const deauthenticate = (): void => {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    setAuthState(state => ({
      ...state,
      isAuthenticated: false,
      isLoading: false,
    }));
  };

  return { setAuthLoading, authenticate, deauthenticate };
};

export const useAuthStateSelector = (): AuthState =>
  useContextSelector(AuthContext, context => context.state);
